var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ul',{staticClass:"box"},_vm._l((_vm.imgList),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb995f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CutImg.vue
// module id = null
// module chunks = 